<template>
    <div class="header-teaser-content grid" :class="rootClasses" v-bind="cmsEditHelperAttrs">
        <div class="header-teaser-content--pattern"></div>
        <div class="grid--container">
            <div class="header-teaser-content--row grid--row">
                <div class="header-teaser-content--col grid--col">
                    <!-- <pre v-if="content" v-text="content"></pre> -->
                    
                    <a :href="content.href || '#'" @click.prevent="requestLink"
                            class="u-reset header-teaser-content--link"
                            :class="linkClasses">
                        <b class="header-teaser-content--title" v-text="content.title"></b>
                        <hr class="header-teaser-content--line">
                        <p class="header-teaser-content--text" v-text="content.text"></p>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import cmsPlugin from 'vue/mixins/cms/cms-plugin';
    import bemMixin from 'vue/mixins/bem';
    
    
    export default {
        mixins: [
            cmsPlugin,
            bemMixin('header-teaser-content'),
        ],
        computed: {
            rootClasses() {
                return [
                    this.bemAdd(`theme-${ this.content.theme || 'neutral' }`),
                ];
            },
            hasLink() {
                return this.content.href;
            },
            linkClasses() {
                return [
                    this.bemAdd(this.hasLink ? '' : 'empty-link', 'link'),
                ];
            },
        },
        methods: {
            requestLink() {
                if (this.hasLink) {
                    this.$emit('request-close');
                    this.$router.push(this.content.href);
                }
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?fb159802